import React from 'react';
import config from '../config';

interface ButtonLinkProps {
  urlKey: keyof typeof config.LINKS | keyof typeof config.app.routes;
  label: string;
  className?: string;
  source?: 'links' | 'routes';
  target?: '_blank' | '_self'; 
}

const ButtonLink: React.FC<ButtonLinkProps> = ({
  urlKey,
  label,
  className = "",
  source = 'links',
  target
}) => {
  const url =
    source === 'links'
      ? config.LINKS[urlKey as keyof typeof config.LINKS]
      : config.app.routes[urlKey as keyof typeof config.app.routes];

  if (!url) {
    console.error(`Invalid URL key or Please check source: ${urlKey}`);
    return null;
  }

  return (
    <a
      href={url}
      className={className}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
    >
      {label}
    </a>
  );
};

export default ButtonLink;
